(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-brand-search]')) return;
    const panel = event.target.closest('[data-brand-panel]');
    if (!panel) return;
    const query = event.target.value.trim().toLowerCase();
    const items = panel.querySelectorAll('[data-brand-name]');
    let matches = 0;
    items.forEach((item) => {
      const visible = item.dataset.brandName.includes(query);
      item.hidden = !visible;
      if (visible) matches += 1;
    });
    const empty = panel.querySelector('[data-brand-empty]');
    if (empty) empty.hidden = matches !== 0;
  });
  } catch(e) { console.error(e); }
})();

})();
